import { useState, useEffect } from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { TUTORIAL_NAME } from 'shared/utils/tutorial';

function useCheckSidebarZindex({ isMenuVisible }) {
  const [zIndex, setZIndex] = useState(390);

  const isBlockedForMissionsTutorial = useSelector(
    state => state.tutorial.blockLobby && state.tutorial.tutorialName === TUTORIAL_NAME.MISSIONS_TUTORIAL
  );

  useEffect(() => {
    if (isBlockedForMissionsTutorial) {
      setZIndex(200);
    } else if (isMenuVisible && isMobile && !isTablet) {
      setZIndex(1390);
    } else if (!isMenuVisible && isMobile && !isTablet && zIndex === 1390) {
      const timer = setTimeout(() => {
        setZIndex(390);
      }, 400);
      return () => clearTimeout(timer);
    } else if (!isMobile || isTablet) {
      setZIndex(390);
    }
  }, [isMenuVisible, isBlockedForMissionsTutorial, zIndex]);

  return zIndex;
}

export default useCheckSidebarZindex;

